import { environment } from 'environments/environment';

export default {
  graphqlEndpoint: environment.aws.aws_appsync_graphqlEndpoint,
  region: environment.aws.aws_appsync_region,
  authenticationType: environment.aws.aws_appsync_authenticationType
};
